export const normalizeRating = (rating) => {
  if (!rating || rating < 0) return 0;
  if (rating > 5) return 5.0;
  return Math.round(rating * 10) / 10;
};
